import { SurveyAudiencePresentation } from '../models/survey-presentation.model';

export const SURVEY_AUDIENCE_BANNER = {
  NONE: 'none',
  GROUP_MC: 'group-mc',
} as const;

export const DEFAULT_AUDIENCE_PRESENTATION: SurveyAudiencePresentation = {
  targeting: 'full',
  saveDisabled: false,
  metadataConfig: {
    title: { disabled: false },
    template: { disabled: false },
    tags: { disabled: false },
    country: { selection: 'multiple', disabled: false },
    language: { selection: 'multiple', disabled: false },
    completes: { disabled: false },
    loi: { disabled: false },
    incidence: { disabled: false },
    fieldTime: { disabled: false },
    clickBalancing: { disabled: false },
    descriptions: [],
  },
  banner: SURVEY_AUDIENCE_BANNER.NONE,
};
